import React, { useEffect } from 'react';
import { useSelector } from '~/redux';
import { styled } from '~/styles';
import config from '~/config';

const StyledLogs = styled.div`
padding: 15px;

ul {
  li {
    display: block;
    margin-bottom: 15px;
    p {
      font-size: 0.8em;
    }
  }
}
`;

function LogsPage() {
  const resources = useSelector((state) => state.resources);

  function prettifyDate(date: string): string {
    return new Date(date).toString();
  }

  useEffect(() => {
    if (config.debug) { console.log(resources); }
  }, []);

  return(
    <StyledLogs>
        <h2>Resources</h2>
        <ul>
          {
          resources.all.map((resource, index) => 
            
            <li key={index}>
              <table>
                <thead>
                  <tr>
                    <th colSpan={2}><h3 dangerouslySetInnerHTML={ { __html: resource.title } } /></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Description</td>
                    <td><span dangerouslySetInnerHTML={ { __html: resource.description } } /></td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td><span dangerouslySetInnerHTML={ { __html: resource.type } } /></td>
                  </tr>
                  <tr>
                    <td>Thumbnail</td>
                    <td>
                      <img src={config.strapiAPI.URL.slice(0, -1) + resource.thumbnail?.url} /><br/>
                      <span dangerouslySetInnerHTML={ { __html: config.strapiAPI.URL.slice(0, -1) + resource.thumbnail?.url } } />
                    </td>
                  </tr>
                  <tr>
                    <td>Created</td>
                    <td><span dangerouslySetInnerHTML={ { __html: prettifyDate(resource.created_at) } } /></td>
                  </tr>
                  <tr>
                    <td>Updated</td>
                    <td><span dangerouslySetInnerHTML={ { __html: prettifyDate(resource.updated_at) } } /></td>
                  </tr>
                  <tr>
                    <td>Published</td>
                    <td><span dangerouslySetInnerHTML={ { __html: prettifyDate(resource.published_at) } } /></td>
                  </tr>
                </tbody>
              </table>
            </li>
          )}
        </ul>
    </StyledLogs>
  )
}

export default LogsPage;


// WEBPACK FOOTER //
// ./src/pages/logs/index.tsx